<template>
  <div class="search d-flex align-center justify-center">
    <div class="content d-flex f-column align-center justify-center">
      <h3>查询溯源 助力追溯来源 真实产品源头</h3>
      <p>真实、公开、透明的猪肉产品信息追溯平台+打通生猪产业链从养殖-屠宰加工</p>
      <p>-检疫检查-物流运输-销售各环节，为社会各界提供猪肉全流程信息溯源</p>
      <div class="list d-flex align-center">
        <div class="item">
          <el-image
            class="image"
            :src="require('@/assets/images/search_01.png')"
          ></el-image>
          <div class="info d-flex align-center justify-center">
            <div class="desc">
              <div class="text">养殖环节</div>
              <span>Breeding</span>
            </div>
          </div>
        </div>
        <div class="item">
          <el-image
            class="image"
            :src="require('@/assets/images/search_02.png')"
          ></el-image>
          <div class="info d-flex align-center justify-center">
            <div class="desc">
              <div class="text">屠宰加工</div>
              <span>Processing</span>
            </div>
          </div>
        </div>
        <div class="item">
          <el-image
            class="image"
            :src="require('@/assets/images/search_03.png')"
          ></el-image>
          <div class="info d-flex align-center justify-center">
            <div class="desc">
              <div class="text">检疫检测</div>
              <span>Quarantine</span>
            </div>
          </div>
        </div>
        <div class="item">
          <el-image
            class="image"
            :src="require('@/assets/images/search_04.png')"
          ></el-image>
          <div class="info d-flex align-center justify-center">
            <div class="desc">
              <div class="text">物流运输</div>
              <span>logistics</span>
            </div>
          </div>
        </div>
        <div class="item">
          <el-image
            class="image"
            :src="require('@/assets/images/search_05.png')"
          ></el-image>
          <div class="info d-flex align-center justify-center">
            <div class="desc">
              <div class="text">销售环节</div>
              <span>Consumption</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.search {
  height: 9rem;
  background-color: #f9fafe;
  .content {
    h3 {
      font-size: 0.45rem;
      margin-bottom: 0.3rem;
    }
    p {
      font-size: 0.25rem;
      color: #666;
      padding: 0.1rem 0;
    }
    .list {
      padding-top: 1.225rem;
      .item {
        margin-right: 0.775rem;
        &:last-of-type {
          margin-right: 0;
        }
      }
      .image {
        display: block;
        width: 2.5rem;
        height: 2.5rem;
      }
      .info {
        padding-top: 0.625rem;
        font-size: 0.25rem;
        color: #666;
        .desc {
          text-align: center;
        }
        .text {
          margin-bottom: 0.125rem;
        }
        span {
          text-transform: uppercase;
          font-size: 0.1875rem;
          color: #999;
        }
      }
    }
  }
}
</style>
